import $ from 'jquery';
import { fabric } from 'fabric';
import { v4 as uuidv4 } from 'uuid';
import { triggerStateChangedRequest, generateObjRefId } from '~core';
import { isURL } from '~src/utils';

const onSvgAdded = (svgOptions, cb) => (objects, options) => {
  if (objects && objects.length > 0) {
    objects.map((object) => {
      object.id = uuidv4();
    });
  }

  const loadedObject = fabric.util.groupSVGElements(objects, options);

  if (!svgOptions.giotto) {
    svgOptions.giotto = {
      objRefId: generateObjRefId('logo'),
    };
  }

  loadedObject.id = uuidv4();
  loadedObject.set({
    left: 100,
    top: 100,
    angle: 0,
    ...svgOptions,
  });

  if (svgOptions && svgOptions.width) {
    loadedObject.scaleToWidth(svgOptions.width);
  }
  window.canvas.add(loadedObject);
  window.canvas.setActiveObject(loadedObject);
  window.canvas.renderAll();

  triggerStateChangedRequest();
  $('.editor-sidebar-image-injection-loader').remove();
  cb(loadedObject);
};

export const addSvgToCanvas = (svgInput, svgOptions = {}) => {
  return new Promise((resolve, reject) => {
    if (!svgInput) {
      const error = new Error(
        'Cannot add svg to canvas. Missing SVG parameter'
      );
      reject(error);
      return;
    }

    const isUrl = isURL(svgInput);

    if (isUrl) {
      fabric.loadSVGFromURL(svgInput, onSvgAdded(svgOptions, resolve));
    } else {
      fabric.loadSVGFromString(svgInput, onSvgAdded(svgOptions, resolve));
    }
  });
};
